import Notification from './components/notifications';
import Breadcrumbs from './components/breadcrumbs';

window.jQuery = window.$ = require('jquery');
var processInclude = require('./util');

require('bootstrap/js/src/collapse.js');
require('bootstrap/js/src/dropdown.js');
require('bootstrap/js/src/modal.js');
require('bootstrap/js/src/tab.js');
require('bootstrap-select/js/bootstrap-select');
require('slick-carousel/slick/slick');
require('./components/spinner');

$(document).ready(function () {
    processInclude(require('./common/common'));
    processInclude(require('./navigation/header'));
    processInclude(require('./navigation/menuNav'));
    processInclude(require('./navigation/search'));
    processInclude(require('./experience/experience'));
    processInclude(require('./components/analytics'));
});

Notification.init();
Breadcrumbs.init();

// TODO Matteo: Rework file
